import clsx from 'clsx';

import {
  Client,
  isCurrentClient,
} from '@atom/utilities/featureToggleUtilities';

import { View } from './InventoryExportContext';

import classes from './inventoryExport.module.css';

interface Props {
  activeView: View;
  setActiveView: (view: View) => void;
}

const InventoryExportSidebar = ({ activeView, setActiveView }: Props) => {
  return (
    <div style={{ flexDirection: 'column' }}>
      <div style={{ height: '0.5rem' }} />
      <div
        className={clsx(
          classes.row,
          View.DATA_EXPORTS === activeView && classes.selected,
        )}
        onClick={() => setActiveView(View.DATA_EXPORTS)}
      >
        <div className={classes.rowName}>Data Exports</div>
      </div>
      {isCurrentClient([Client.HENNEPIN]) && (
        <div
          className={clsx(
            classes.row,
            View.CUSTOM_EXPORTS === activeView && classes.selected,
          )}
          onClick={() => setActiveView(View.CUSTOM_EXPORTS)}
        >
          <div className={classes.rowName}>Custom Exports</div>
        </div>
      )}
    </div>
  );
};

export default InventoryExportSidebar;
